import { useFrame, useLoader } from "@react-three/fiber"
import { motion } from "framer-motion-3d";
import { Html } from "@react-three/drei";
import { useEffect, useMemo, useRef, useState } from "react"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { useBodyClass } from "../utils/hook";

export default function Earth() {
    const gltf = useLoader(GLTFLoader, `${process.env.PUBLIC_URL}/assets/model/earth.glb`)
    const ref = useRef(null)
    const [isHover, setHover] = useState(false);

    const model = useMemo(() => {
        if (gltf.nodes.earth) {
            let clonedModel = gltf.nodes.earth;
            return clonedModel;
        }
    }, [gltf])

    useFrame((_, delta)=>{
        if(ref.current) ref.current.rotation.y += delta * 0.1;
    })

    useBodyClass(isHover, "drag")

    return (
        <group>
            <motion.mesh 
                ref={ref} 
                scale={8} 
                position={[0,-10, 1]}
                onPointerEnter={()=> setHover(true)}
                onPointerOut={()=> setHover(false)}
                rotation-x={1}
                receiveShadow
                >
                <primitive object={model} />
            </motion.mesh>
            <Html 
                center
                position={[0,-10,0]}
                >
                <div className="rotation-icon"/>
            </Html>
        </group>
    )
}